const env = {
  apiUrl: import.meta.env.VITE_API_URL,
  /** Host for the MCP server. Production has its own, elsewhere it is the app API. */
  mcpUrl: import.meta.env.VITE_ENVIRONMENT === `production` ? `https://mcp.paidnice.com` : import.meta.env.VITE_API_URL,
  environment: import.meta.env.VITE_ENVIRONMENT,
  gtmId: import.meta.env.VITE_GTM_ID, // e.g 'GTM-000000'
  mixpanelToken: import.meta.env.VITE_MIXPANEL_TOKEN,
  maintenanceMode: import.meta.env.VITE_MAINTENANCE_MODE === `true`,
  frigatePublicKey: import.meta.env.VITE_ENVIRONMENT === `production`
    ? `api_public_ema5aE1ik2Wf4qSAycc1e1OXlNJzFR5QWyVmkebxwUwTIhaPNbYPKHQdy8QICqId`
    : `api_public_B4uDrfpY7Red9QZluPiMZan67VolYYf0tPHXHCJvSmK9g4UmyJR83KwlTNi6N1aV`, // NOT A SECRET
  // Dev Tools
  frigateSetupFlowId: import.meta.env.VITE_ENVIRONMENT === `production`
    ? `flow_IiD9HYRRk6aff8Zt`
    : `flow_IbxaEFwSmRtkaunU`,
  noPolling: import.meta.env.VITE_NO_POLLING === `true`,
  legacyPolicyUser: import.meta.env.VITE_LEGACY_POLICY_USER === `true`,
  /** Local only: view any onboarding screen regardless of the org's real onboarding state */
  forceOnboarding: import.meta.env.VITE_FORCE_ONBOARDING === `true` && import.meta.env.VITE_LOCAL === `true`,
  baseApiUrl: ``,
  basePortalApiUrl: ``,
  isProd: false,
  isDev: false,
  isLocal: import.meta.env.VITE_LOCAL === `true`,
  /** Demo stack build (npm run demo, hosted demo workflow) */
  paidniceDemo: import.meta.env.VITE_PAIDNICE_DEMO === `true`,
  portalWebUrl: import.meta.env.VITE_PORTAL_URL,
  stripePublicKey: import.meta.env.VITE_STRIPE_PUBLIC_KEY,
  portalAuth0ClientId: import.meta.env.VITE_PORTAL_AUTH0_CLIENT_ID,
  portalAuth0Domain: import.meta.env.VITE_PORTAL_AUTH0_DOMAIN,
  auth0BackendApiAudience: import.meta.env.VITE_AUTH0_BACKEND_API_AUDIENCE,
  muiLicenceKey: import.meta.env.VITE_MUI_LICENCE_KEY,
  logrocketAppId: import.meta.env.VITE_LOGROCKET_APP_ID,
  /** VITE_SENTRY_ENABLED=false skips Sentry init while keeping DSNs set */
  sentryEnabled: import.meta.env.VITE_SENTRY_ENABLED !== `false`,
  sentryDsnApp: import.meta.env.VITE_SENTRY_DSN_APP,
  sentryDsnPortal: import.meta.env.VITE_SENTRY_DSN_PORTAL,
  newPolicyLayout: import.meta.env.VITE_NEW_POLICY_TEST === `true`,
  logrocketProxyOverride: import.meta.env.VITE_LOGROCKET_PROXY_OVERRIDE,
};

// Extra Helpers
env.baseApiUrl = `${env.apiUrl}/api/v1/`;
env.basePortalApiUrl = `${env.apiUrl}/api/portal/`;
env.isProd = env.environment === `production`;
env.isDev = env.environment !== `production` && env.environment !== `staging`;

export {
  env,
};
